import { useState } from "react";
import { DropdownItemButton } from "../../common/DropdownItemButton";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu } from "../models/Menus";
import { DuplicateMenuAndProductsForm } from "./DuplicateMenuAndProductsForm";

type Props = {
  menuItem: Menu | undefined;
};

export const DuplicateMenuAndProductsSelector = ({ menuItem }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      <DropdownItemButton
        onClick={() => {
          setModalOpen(true);
        }}
        icon={<FontAwesomeIcon icon={solid("copy")} />}
      >
        Duplicate menu and products
      </DropdownItemButton>
      <DuplicateMenuAndProductsForm
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        menuItem={menuItem}
      />
    </>
  );
};
